export const ProductSteps = {
    GENERAL_INFORMATION: {
      id: 1,
      name: "general_information"
    },
    CLASSIFICATION: {
      id: 2,
      name: "classification"
    },
    PRICING: {
      id: 3,
      name: "pricing"
    },
    SHIPPING: {
      id: 4,
      name: "shipping"
    },
  };